import { render, staticRenderFns } from "./modalVideo.vue?vue&type=template&id=a041347a&"
import script from "./modalVideo.vue?vue&type=script&lang=js&"
export * from "./modalVideo.vue?vue&type=script&lang=js&"
import style0 from "./modalVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "modalVideo.vue"
export default component.exports